import { Button, Drawer, DrawerBody, DrawerContent, DrawerHeader, DrawerOverlay, flatten, HStack, useDisclosure, VStack } from '@chakra-ui/react'
import React from 'react'
import {ColorModeSwitcher} from "../../../ColorModeSwitcher"
import {RiDashboardFill, RiLogoutBoxLine, RiMenu5Fill} from "react-icons/ri"
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../../redux/actions/user'

const Header = ({isAuth=false,user}) => {
    const {isOpen,onOpen,onClose} = useDisclosure()
    // const user ={
    //     role : "admin"
    // }
    // const {} = useSelector(state=>state.user)
    // const isAuth = false;
    // const {isAuth,user} = useSelector(state=> state.user)
    const dispatch = useDispatch();
    const logoutHandler = ()=>{
        onClose();
        dispatch(logout());
    }
  return (
    <>
        <ColorModeSwitcher/>

        <Button onClick={onOpen} colorScheme={"yellow"} width="12" height={'12'} rounded="full" position={"fixed"} top="6" left="6">
            <RiMenu5Fill />
        </Button>

        <Drawer placement='left' onClose={onClose} isOpen={isOpen}>
            <DrawerOverlay backdropFilter={"blur(5px)"}/>
            <DrawerContent>
                <DrawerHeader borderBottomWidth={'1px'}>Best Courses</DrawerHeader>
                <DrawerBody>
                    <VStack spacing={'4'} alignItems='flex-start'>
                        <Link onClick={onClose} to = "/">
                            <Button  variant='outline'>Home</Button>
                        </Link>
                        <Link onClick={onClose} to = "/courses">
                            <Button  variant='outline'>Available Courses</Button>
                        </Link>
                        <Link onClick={onClose} to = "/request">
                            <Button  variant='outline'>Request Courses</Button>
                        </Link>
                        <Link onClick={onClose} to = "/contact">
                            <Button  variant='outline'>Contact Us</Button>
                        </Link>
                        <Link onClick={onClose} to = "/about">
                            <Button  variant='outline'>About Us</Button>
                        </Link>
                        <HStack justifyContent={'space-evenly'} position='absolute' bottom={'2rem'} width='80%'>
                            {isAuth ? 
                            (
                                <>
                                    <VStack>
                                        <HStack>
                                            <Link onClick={onClose} to="/profile">
                                                <Button colorScheme={'pink'} variant='outline'>Profile</Button>
                                            </Link>
                                            <Button colorScheme={'pink'} variant='outline' onClick={logoutHandler}><RiLogoutBoxLine/>Logout</Button>
                                        </HStack>
                                        {
                                            user && user.role==="admin" && <Link onClick={onClose} to ="/admin/dashboard">
                                                <Button colorScheme={'purple'} variant='outline'>
                                                    <RiDashboardFill style={{margin:'4px'}}/>
                                                    Dashboard
                                                </Button>
                                            </Link>
                                        }
                                    </VStack>
                                </>
                            ) : 
                            (
                            <>
                                <Link onClick={onClose} to="/login">
                                    <Button colorScheme={'pink'} variant='outline'>Login</Button>
                                </Link>
                                <p> OR </p>
                                <Link onClick={onClose} to="/register">
                                    <Button colorScheme={'pink'} variant='outline'>Register</Button>
                                </Link>
                            </>)}
                        </HStack>
                    </VStack>
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    </>
  )
}

export default Header